import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getSocialPlatformConfigs,
  saveSocialPlatformConfigs,
  getVendorSourceContent,
  getVendorSocialPosts,
  createVendorSocialPost,
  updateVendorSocialPost,
  deleteVendorSocialPost,
  pushVendorSocialPostNow,
} from '../../services/SocialMediaServices';
import * as actions from './actions';

function getSocialErrorMessage(error) {
  if (!error) {
    return 'Unknown social media error.';
  }

  const message =
    (error.message && String(error.message).trim()) ||
    'Social media request failed.';
  const hasCode = error.code && String(error.code).trim() !== '';

  return hasCode ? `[${error.code}] ${message}` : message;
}

function* getSocialConfigAction() {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingConfig: true,
        error: null,
      },
    });

    const platforms = yield call(getSocialPlatformConfigs);

    yield put({
      type: actions.SET_SOCIAL_CONFIG,
      payload: {
        platforms,
        loadingConfig: false,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingConfig: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

function* saveSocialConfigAction(action) {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: true,
        saveSuccess: false,
        error: null,
      },
    });

    const platforms = yield call(
      saveSocialPlatformConfigs,
      action.payload.configs,
      action.payload.updatedBy,
    );

    yield put({
      type: actions.SET_SOCIAL_CONFIG,
      payload: {
        platforms,
      },
    });

    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: true,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

function* getVendorSocialContentAction(action) {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingContent: true,
        error: null,
      },
    });

    const content = yield call(
      getVendorSourceContent,
      action.payload.vendorId,
      action.payload.contentType,
    );

    yield put({
      type: actions.SET_VENDOR_SOCIAL_CONTENT,
      payload: {
        vendorContent: content,
        vendorContentType: action.payload.contentType,
      },
    });

    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingContent: false,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingContent: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

function* getVendorSocialPostsAction(action) {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingPosts: true,
        error: null,
      },
    });

    const posts = yield call(
      getVendorSocialPosts,
      action.payload.vendorId,
    );

    yield put({
      type: actions.SET_VENDOR_SOCIAL_POSTS,
      payload: {
        posts,
      },
    });

    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingPosts: false,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        loadingPosts: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

function* createVendorSocialPostAction(action) {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: true,
        saveSuccess: false,
        error: null,
      },
    });

    yield call(createVendorSocialPost, action.payload);

    const posts = yield call(
      getVendorSocialPosts,
      action.payload.vendorId,
    );

    yield put({
      type: actions.SET_VENDOR_SOCIAL_POSTS,
      payload: {
        posts,
      },
    });

    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: true,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

function* updateVendorSocialPostAction(action) {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: true,
        saveSuccess: false,
        error: null,
      },
    });

    yield call(updateVendorSocialPost, action.payload);

    const posts = yield call(
      getVendorSocialPosts,
      action.payload.vendorId,
    );

    yield put({
      type: actions.SET_VENDOR_SOCIAL_POSTS,
      payload: {
        posts,
      },
    });

    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: true,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

function* deleteVendorSocialPostAction(action) {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: true,
        saveSuccess: false,
        error: null,
      },
    });

    yield call(deleteVendorSocialPost, action.payload.postId);

    const posts = yield call(
      getVendorSocialPosts,
      action.payload.vendorId,
    );

    yield put({
      type: actions.SET_VENDOR_SOCIAL_POSTS,
      payload: {
        posts,
      },
    });

    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: true,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

function* pushVendorSocialPostNowAction(action) {
  try {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: true,
        saveSuccess: false,
        error: null,
      },
    });

    yield call(pushVendorSocialPostNow, action.payload);

    const posts = yield call(
      getVendorSocialPosts,
      action.payload.vendorId,
    );

    yield put({
      type: actions.SET_VENDOR_SOCIAL_POSTS,
      payload: {
        posts,
      },
    });

    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: true,
      },
    });
  } catch (error) {
    yield put({
      type: actions.SET_SOCIAL_STATUS,
      payload: {
        saving: false,
        saveSuccess: false,
        error: getSocialErrorMessage(error),
      },
    });
  }
}

export default function* sagas() {
  yield takeLatest(actions.GET_SOCIAL_CONFIG, getSocialConfigAction);
  yield takeLatest(
    actions.SAVE_SOCIAL_CONFIG,
    saveSocialConfigAction,
  );
  yield takeLatest(
    actions.GET_VENDOR_SOCIAL_CONTENT,
    getVendorSocialContentAction,
  );
  yield takeLatest(
    actions.GET_VENDOR_SOCIAL_POSTS,
    getVendorSocialPostsAction,
  );
  yield takeLatest(
    actions.CREATE_VENDOR_SOCIAL_POST,
    createVendorSocialPostAction,
  );
  yield takeLatest(
    actions.UPDATE_VENDOR_SOCIAL_POST,
    updateVendorSocialPostAction,
  );
  yield takeLatest(
    actions.DELETE_VENDOR_SOCIAL_POST,
    deleteVendorSocialPostAction,
  );
  yield takeLatest(
    actions.PUSH_VENDOR_SOCIAL_POST_NOW,
    pushVendorSocialPostNowAction,
  );
}
